document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customCategory();
    customPerex();
    customProductTop();
    customProductsSlider();
    customFiltration();
    customCategoryBanner();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customCategory();
    customPerex();
    customProductTop();
    customProductsSlider();
    customFiltration();
    customCategoryBanner();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customCategory();
    customPerex();
    customProductTop();
    customProductsSlider();
    customFiltration();
    customCategoryBanner();
});
$(document).ready(function(){
    customCategory();
    customPerex();
    customProductTop();
    customProductsSlider();
    customFiltration();
    customCategoryBanner();
});

function customCategory(){
    $('.customCategoryTop').remove();
    if($('.type-category').length){
        if(!$('.type-category header#header+.customCategoryTop').length){
            $('header#header').after('<div class="customCategoryTop"><div class="container"><div class="customCategoryTopWrap"></div></div></div>');
            $('.customCategoryTop .customCategoryTopWrap').append($('.breadcrumbs-wrapper').clone())
            $('.customCategoryTop .customCategoryTopWrap').append($('.category-top .category-title'), $('.category-top .category-perex'));
        }
    }
    
    $('body').addClass('categoryClass-'+$('.breadcrumbs').first().find('#navigation-1 [itemprop="name"]').text().trim().normalize("NFD").replace(/\p{Diacritic}/gu, "").replace(/\s+/g, "-").replace(/[^a-zA-Z0-9\-]/g, "").toLowerCase())
}


function customFiltration(){
    if(!$('#category-header .filters-unveil-button-wrapper').length){
        $('#category-header').append($('.filters-unveil-button-wrapper').clone());
    }
    if(!$('#category-header .customSorting').length){
        $('#category-header').append('<span class="customSorting">'+translation('sortingBy')+'</span>');
    }
}

$('html').on('click', '.customSorting', function(){
    $(this).closest('#category-header').find('.listSorting').toggleClass('showSorting');
});

function customProductTop() {
    $('#productsTop.products .product').each(function(){
        if(!$(this).find('.p-bottom .p-tools').length){
            $(this).find('.p-bottom>div').append('<div class="p-tools"><a href="'+$(this).find('a.image').attr('href')+'">'+translation('detailTopProducts')+'</a></div>')
        }
    })
    $('#productsTopHeading').text(translation('nejprodavanejsivkategorii'));
    if ($('.products-top-wrapper h2 .brandArrows').length === 0) {
        $('.products-top-wrapper h2').append('<div class="brandArrows"></div>');
    }
}

function customProductsSlider(){
    if(!$('#productsTop.products.slick-slider').length){
        $('#productsTop.products').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: true,
            arrows: true,
            infinite: false,
            adaptiveHeight: false,
            appendArrows: $('#productsTopHeading .brandArrows'),
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 }},
                { breakpoint: 991,  settings: { slidesToShow: 2, slidesToScroll: 1 }},
                { breakpoint: 767,  settings: { slidesToShow: 2, slidesToScroll: 1, arrows:false, }},
                { breakpoint: 550,  settings: { slidesToShow: 1, slidesToScroll: 1, arrows:false, }}
            ]
        });
    }
}

function customPerex() {
    const $perex = $('.category-perex');
    const $marker = $perex.find('p').filter(function () {
        return $(this).text().trim() === '[cist-vice]';
    });

    if (!$marker.length) return;

    const $before = $marker.prevAll('p');
    const $after = $marker.nextAll('p');

    if (!$after.length) return;

    $marker.remove();

    const $dots = $('<span class="dots"> ...</span>');
    const $toggle = $(`
        <div class="readMore readMoreMore">
            <span class="toggle">${translation('cistVice')}</span>
        </div>
    `);

    const $afterWrap = $('<div class="afterText" style="display:none;"></div>');
    $afterWrap.append($after);

    $before.last().append($dots).after($toggle).after($afterWrap);

    $perex.on('click', '.readMoreMore .toggle', function () {
        if (!$afterWrap.is(':visible')) {
            $afterWrap.slideDown(250);
            $dots.hide();
            $(this).text(translation('cistMene'));
        } else {
            $afterWrap.slideUp(250);
            $dots.show();
            $(this).text(translation('cistVice'));
        }
    });
}



function customCategoryBanner() {

    if (!$('.type-category').length || !$('.customCategoryTop>.container').length) return;

    var $bannerContainer = $('.customCategoryTop>.container');

    $('#categoryBannerTemp').remove();

    var currentUrl = window.location.pathname;

    $.ajax({
        url: 'https://php.shopcode.cz/api/celtic-supply/api-katObr.php',
        method: 'GET',
        dataType: 'json',
        data: {
            location: currentUrl
        },

        success: function(response) {
            if (!response || response.count === 0) {

                $bannerContainer.append(`
                    <div class="categoryBanner categoryBanner-image" style="background-image:url('${zachrannyBanner.img}')">
                        <div class="categoryBanner-inner">
                            <h3>${zachrannyBanner.h3}</h3>
                            <p>${zachrannyBanner.p}</p>
                            <a href="${zachrannyBanner.link}" class="btn">${zachrannyBanner.a}</a>
                        </div>
                    </div>
                `);

                return;
            }

            let img = '/user/documents/upload/bannery/kategorie/banner-kat.png';
            let h3 = '';
            let p = '';
            let a = '';

            if (response.count > 0) {

                const item = response.data[0];

                if (item.url_obrazku) {
                    img = item.url_obrazku;
                }

                if (item.nadpis) {
                    h3 = `<h3>${item.nadpis}</h3>`;
                }

                if (item.popis) {
                    p = `<p>${item.popis}</p>`;
                }

                if (item.url && item.text_odkazu) {
                    a = `<a href="${item.url}" class="btn">${item.text_odkazu}</a>`;
                }

            }

            const hasText = h3 || p || a;

            // IMAGE banner
            if (!hasText) {

                $bannerContainer.append(`
                    <div class="categoryBanner categoryBanner-image" style="background-image:url('${img}')"></div>
                `);

                return;

            }

            // FULL banner
            $bannerContainer.append(`
                <div class="categoryBanner categoryBanner-full" style="background-image:url('${img}')">
                    <div class="categoryBanner-inner">
                        ${h3}
                        ${p}
                        ${a}
                    </div>
                </div>
            `);

        },

        error: function() {

            $bannerContainer.append(`
                <div class="categoryBanner categoryBanner-image" style="background-image:url('${zachrannyBanner.img}')">
                    <div class="categoryBanner-inner">
                       <h3>${zachrannyBanner.h3}</h3>
                        <p>${zachrannyBanner.p}</p>
                        <a href="${zachrannyBanner.link}" class="btn">${zachrannyBanner.a}</a>
                    </div>
                </div>
            `);

        }

    });

}
